<template>
  <v-layout style="width:100%;padding:20px;">
    <v-flex xs3 style="padding:14px;" class="text-xs-right">poorly characterised</v-flex>
    <v-flex xs6>
      <div v-bind:style="{ border: '3px solid' + getColorPctHex(score.substring(0,score.indexOf('%'))), 'padding': '0 5px', 'border-radius': '2px'}">
        <v-progress-linear :value="score.substring(0,score.indexOf('%'))" height=15 :color-front="getColorPct(score.substring(0,score.indexOf('%')))" color-back="blue-grey">
        </v-progress-linear>
      </div>
      <div v-bind:style="{ color: getColorPctHex(score.substring(0,score.indexOf('%'))), 'font-weight' : 600}">{{score}}</div>
    </v-flex>
    <v-flex xs3 style="padding-top:14px;" class="text-xs-left">well characterised</v-flex>
  </v-layout>
</template>

<script>
export default {
  props: ['score'],
  methods: {
    getColorPct(value) {
      let pct = parseInt(value)

      if (pct <= 24) {
        return 'red'
      } else if (pct > 24 && pct <=50) {
        return 'orange'
      } else if (pct > 50 && pct <=75) {
        return 'light-green'
      } else if (pct > 57) {
        return 'green'
      }
    },
    getColorPctHex(value) {
      let pct = parseInt(value)

      if (pct <= 24) {
        return '#F44336'
      } else if (pct > 24 && pct <=50) {
        return '#FF9800'
      } else if (pct > 50 && pct <=75) {
        return '#8BC34A'
      } else if (pct > 57) {
        return '#4CAF50'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// PrbCharacterisation.vue?6c9fb5d4